module.exports = __webpack_public_path__ + "img/W7028-thumb.773599ec.jpg";